



















import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import Utils from "@/store/utils";
import httpApi from "../API/Sys/Menu";
import { log } from "util";
import { getCookie } from "../JS/cookie"; //使用getCookie方法
import Bus from "../JS/Bus";
@Component({
  components: {}
})
export default class LeftMenu extends Vue {
  private LeftMenuRefresh = false;
  private isCollapse:boolean = false;
  private currentMenu = 0;
  /**
   * 菜单的收缩与展开
   */
  navbarFn(){
    this.isCollapse = this.isCollapse?false:true;
  };
  @Provide() menuList: any = [];
  created() {
    this.loadDataList(); 
    this.refresh();
  }
  abtn(clickIndex:any, item: any, subItem: any) {
    // Bus.$emit("myFun", item, subItem);
      this.currentMenu = clickIndex;
      this.$emit('leftToPage',item)
  }
  //刷新菜单
  refresh() {
    Bus.$on("MenuRefresh", (Item: any) => {
      //console.log("刷新菜单");
      this.loadDataList();
    });
  }
  async loadDataList() {
    //本地存储
    // let GetAppAccount = localStorage.getItem("GetAppAccount");
    // if (GetAppAccount) {
    //   var result = Utils.decrypt(GetAppAccount, "");
    //   let AppAccount = JSON.parse(result);
    //   aid = AppAccount.Aid;
    //   //this.items=[];
    // }

    //定义参数
    let params: any = {
      Input: [
        { Name: "aid", value: getCookie("Aid") },
        { Name: "parentcode", value: "-1" }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.GetMenusByUserAndParentCode(params);
    this.menuList = res;
  }

  //   生命周期
  //mounted() {}
}
